import { createApiClientForEndpoint } from "../lib/apiClient";

const api = createApiClientForEndpoint("alarm-buttons");

export const listAlarmButtons = () => api.get("");

export const createAlarmButton = (data) => api.post("", data);

export const updateAlarmButton = (id, data) => api.put(`/${id}`, data);

export const deleteAlarmButton = (id) => api.delete(`/${id}`);
